import { render, staticRenderFns } from "./ExportCourseGift.vue?vue&type=template&id=0bd4e4b4&scoped=true"
import script from "./ExportCourseGift.vue?vue&type=script&lang=js"
export * from "./ExportCourseGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4e4b4",
  null
  
)

export default component.exports